import React, {useState} from 'react';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import {API_URL} from '../../constants';
import {AXIOS_NOT_FOUND_REDIRECT_OPT_OUT} from '../../axiosNotFoundRedirect';

const PickupBillingDocuments = ({pickupId, token, receiptAvailable = false}) => {
    const [downloadingDocument, setDownloadingDocument] = useState(null);

    const downloadDocument = async (documentType) => {
        const documentLabel = documentType === 'receipt' ? 'receipt' : 'invoice';

        setDownloadingDocument(documentType);

        try {
            const response = await axios.get(
                `${API_URL}/api/admin/pickups/${pickupId}/${documentType}/pdf`,
                {
                    ...AXIOS_NOT_FOUND_REDIRECT_OPT_OUT,
                    headers: {Authorization: `Bearer ${token}`},
                }
            );
            const pdfUrl = response.data?.[`${documentType}_pdf`] || response.data?.url;

            if (!pdfUrl) {
                window.alert(`${documentLabel.charAt(0).toUpperCase() + documentLabel.slice(1)} not found for this delivery.`);
                return;
            }

            window.open(pdfUrl, '_blank', 'noopener,noreferrer');
        } catch (error) {
            if (error.response?.status === 404) {
                window.alert(`No ${documentLabel} found for this delivery.`);
            } else {
                console.error(`Error fetching the ${documentLabel} URL:`, error);
                window.alert(`Failed to fetch the ${documentLabel}. Please try again later.`);
            }
        } finally {
            setDownloadingDocument(null);
        }
    };

    return (
        <div className="d-flex justify-content-center flex-wrap mt-4">
            <button
                type="button"
                className={`btn btn-primary mb-2 ${receiptAvailable ? 'mr-2' : ''}`}
                onClick={() => downloadDocument('invoice')}
                disabled={downloadingDocument !== null}
            >
                {downloadingDocument === 'invoice'
                    ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Downloading...</>
                    : 'Download Invoice'
                }
            </button>
            {receiptAvailable && (
                <button
                    type="button"
                    className="btn btn-outline-primary mb-2"
                    onClick={() => downloadDocument('receipt')}
                    disabled={downloadingDocument !== null}
                >
                    {downloadingDocument === 'receipt'
                        ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Downloading...</>
                        : 'Download Receipt'
                    }
                </button>
            )}
        </div>
    );
};

export default PickupBillingDocuments;
